import { WarningDialog } from '@shared/components/WarningDialog/WarningDialog';

interface SwitchPlanModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  categoryLabel: string;
  loading?: boolean;
}

export const SwitchPlanModal = ({ open, onClose, onConfirm, categoryLabel, loading }: SwitchPlanModalProps) => {
  const allCategories = ['Internet', 'TV', 'Phone'];
  const otherCategories = allCategories.filter((c) => c.toLowerCase() !== categoryLabel.toLowerCase());
  const otherCategoriesText = otherCategories.join(' or ');

  return (
    <WarningDialog
      open={open}
      title={`Switch ${categoryLabel} Plan?`}
      description={`Choosing this will replace the ${categoryLabel.toLowerCase()} plan currently in your cart. Any ${otherCategoriesText} plan currently added will remain in your cart if you switch ${categoryLabel.toLowerCase()} plans.`}
      outlinedButtonText="Cancel"
      containedButtonText="Switch Plan"
      loading={loading}
      onOutlinedClick={onClose}
      onContainedClick={onConfirm}
      onClose={onClose}
    />
  );
};
